import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redeem } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';

import { NotificationProps } from '@/features/notifications/types/NotificationProps';
import {
  dismissReferralsBanner,
  isReferralsAvailableForCurrentCompany,
  isReferralsBannerDismissed,
} from '@/features/referrals';
import CompanyContext from '@/providers/CompanyContext';
import { durandalRoutes } from '@/routes/durandal';

const title = <FormattedMessage defaultMessage="Refer a business, earn rewards" />;
const description = (
  <FormattedMessage defaultMessage="Share Plooto and enjoy 4 FREE months of subscription for every successful referral." />
);

export const useReferralsNotification = () => {
  const { companyId } = useContext(CompanyContext);
  const { data: isAvailable, isLoading } = useQuery({
    queryKey: ['isReferralsAvailableForCurrentCompany', companyId],
    queryFn: isReferralsAvailableForCurrentCompany,
  });
  const isUnread = !isReferralsBannerDismissed();
  const notification: NotificationProps = {
    key: 'Referrals',
    isLoading,
    isUnread,
    href: durandalRoutes.user.referrals,
    target: '_self',
    markAsRead: dismissReferralsBanner,
    Icon: Redeem,
    title,
    description,
  };
  return isAvailable ? notification : null;
};
